"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageSurveyLinkModuleLayouts = void 0;
exports.SetPageSurveyLinkModuleLayouts = [
    "image-background",
    "image-left",
];
//# sourceMappingURL=SurveyLink.js.map